import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;

  > div {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: ${({ theme }) => theme.spacing.sm};
  }
`;
